import { jsx as _jsx } from "react/jsx-runtime";
import { getUrlPrefixFromView, useNavigate } from 'frontend/js/modules/infra/routing';
import { useSession } from 'frontend/js/modules/infra/session';
import { AutomatedLayout } from './automated-layout';
export var AutomatedLayoutContainer = function (_a) {
    var children = _a.children;
    var navigate = useNavigate();
    var session = useSession().data;
    var urlPrefix = getUrlPrefixFromView(session.view);
    var handleClose = function () {
        navigate("".concat(urlPrefix, "/engagement/automated"));
    };
    return _jsx(AutomatedLayout, { onCloseCampaign: handleClose, children: children });
};
